import styled, { css } from 'styled-components';

import Colors from '../../../../styles/colors';

const LEVEL_COLOR: {
  [key: number]: { hover: string; active: string; background: string };
} = {
  0: {
    background: 'transparent',
    hover: Colors.abnGreen600,
    active: 'transparent',
  },
  1: {
    background: Colors.abnGreen500,
    hover: Colors.abnGreen400,
    active: Colors.abnGreen500,
  },
  2: {
    background: Colors.abnGreen600,
    hover: Colors.abnGreen600,
    active: Colors.abnGreen600,
  },
  3: {
    background: Colors.abnGreen670,
    hover: Colors.abnGreen670,
    active: Colors.abnGreen670,
  },
};

const sharedMenuItemStyles = css`
  color: inherit;
  cursor: pointer;
  display: flex;
  font-family: ${({ theme }) => theme.fontRegular};
  font-size: inherit;
  font-weight: 400;
  margin: 0;
`;

const MenuItemButton = styled.button<{
  active?: boolean;
  level?: number;
  isMobile?: boolean;
  isMainPanel?: boolean;
}>`
  ${sharedMenuItemStyles}
  align-items: center;
  background-color: ${({ active, level = 0 }) =>
    active
      ? LEVEL_COLOR[level + 1].background
      : LEVEL_COLOR[level].background || 'transparent'};
  border: none;
  gap: 4px;
  padding: 14px 16px;
  text-align: left;
  ${({ isMobile }) => (isMobile ? `width: inherit;` : undefined)};

  ${({ isMainPanel, level = 0, isMobile }) =>
    !isMobile
      ? `&:hover {
      background-color: ${
        isMainPanel ? 'transparent' : LEVEL_COLOR[level].hover
      };
    }  &:active {
    background-color: ${LEVEL_COLOR[level].active};
  }`
      : undefined}
`;

const MenuItemLink = styled.a<{
  active?: boolean;
  level?: number;
  isMobile?: boolean;
  isMainPanel?: boolean;
}>`
  ${sharedMenuItemStyles}
  background-color: ${({ active, level = 0 }) =>
    active
      ? LEVEL_COLOR[level + 1].background
      : LEVEL_COLOR[level].background || 'transparent'};
  padding: ${({ isMainPanel }) => (isMainPanel ? '8px' : '16px')};
  text-decoration: none;

  ${({ isMainPanel, level = 0, isMobile }) =>
    !isMobile
      ? `&:hover {
      background-color: ${
        isMainPanel ? 'transparent' : LEVEL_COLOR[level].hover
      };
    }  &:active {
    background-color: ${LEVEL_COLOR[level].active};
  }`
      : undefined}
`;

export { MenuItemButton, MenuItemLink, sharedMenuItemStyles };
